import { library } from '@fortawesome/fontawesome-svg-core';
import {
  faAllergies,
  faBacteria,
  faBandAid,
  faBrain,
  faBug,
  faCarrot,
  faCloudsSun,
  faCommentMedical,
  faCrutch,
  faEar,
  faEye,
  faFaucet,
  faHandsHoldingHeart,
  faHeadSideCough,
  faHouseChimneyHeart,
  faLungs,
  faMindShare,
  faPills,
  faRibbon,
  faSkullCrossbones,
  faStethoscope,
  faStomach,
  faTooth,
  faTurkey,
  faUserMd,
  faVial,
  faVialVirus,
  faVirusCovid,
  faViruses,
  faWeight,
  faWhistle,
  faWorm,
} from '@fortawesome/pro-light-svg-icons';

library.add({
  faAllergies,
  faBacteria,
  faBandAid,
  faBrain,
  faBug,
  faCarrot,
  faCloudsSun,
  faCommentMedical,
  faCrutch,
  faEar,
  faEye,
  faFaucet,
  faHandsHoldingHeart,
  faHeadSideCough,
  faHouseChimneyHeart,
  faLungs,
  faMindShare,
  faPills,
  faRibbon,
  faSkullCrossbones,
  faStethoscope,
  faStomach,
  faTooth,
  faTurkey,
  faUserMd,
  faVial,
  faVialVirus,
  faVirusCovid,
  faViruses,
  faWeight,
  faWhistle,
  faWorm,
});

export default {};
